export default "__VITE_ASSET__cbfcec16__"